import ThemeColors from '@/styles/colors'

// Shared design tokens for Graph (Cytoscape)
// NOTE: Keep values in sync with existing UI; avoid introducing new colors.

const TOKENS = {
    node: {
        startBorder: '#01C38E',
        endBorder: '#FABFC5',
        loopBorder: '#f29304',
        normalBorder: ThemeColors.quaternary,
        groupedBg: '#f0f7fa',
        defaultBg: '#fff',

        hoverLoopBg: '#fab348',
        hoverDefaultBg: ThemeColors.fifth,
        hoverStartBg: '#07f5b4',
        hoverEndBg: '#fad9dd',
    },
    edge: {
        normalLine: ThemeColors.quaternary,
        normalTextBg: '#f4f4f4',
        normalTextBorder: '#d0d0d0',

        startLine: '#01C38E',
        endLine: '#FABFC5',

        hoverLine: ThemeColors.fifth,
        hoverTextBg: ThemeColors.fifth,

        loopLine: '#f29304',
        overlapLine: '#ef5350',
    },
}

export default TOKENS
